import { App } from '@capacitor/app'
import { useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import logo from '../../assets/images/Justivide-PrimaryIcon.svg'
import PageLayout from '../../components/ui/PageLayout'
import Skeleton from '../../components/ui/Skeleton'
import { ApiConstants } from '../../constants/ApiConstants'
import { Routes } from '../../constants/RouteConstants'
import useMakeRequest from '../../utils/ApiHelper'
import { getLastURL } from '../../utils/Helper'
import DoNotSellMyPersonalInfoModal from '../cms-public/DoNotSellMyPersonalInfoModal'
import TopHeader from '../../components/layouts/TopHeader'

const CmsPages = () => {
    const contentRef = useRef<HTMLDivElement | null>(null);

    const navigate = useNavigate();
    const cmsPage = useMakeRequest();
    const { pathname } = useLocation();
    const slug = getLastURL(pathname);
    console.log("slug: ", slug)
    const title = decodeURIComponent(window?.location?.hash?.split('#').pop() as string);
    console.log("title: ", title)
    useEffect(() => {
        cmsPage.makeRequest({ payload: { detail_id: slug }, url: ApiConstants?.CmsPagesDetail })
    }, [])

    useEffect(() => {
        const handleBackButton = () => {
            navigate(Routes?.Profile);
        };

        App.addListener('backButton', handleBackButton);

        return () => {
            App.removeAllListeners();
        };
    }, [navigate]);

    useEffect(() => {
        const handleContentClick = (event: { target: any; preventDefault: () => void; }) => {
            const clickedElement = event.target;
            if (clickedElement.textContent.includes('Do not share my personal info')) {
                event.preventDefault(); // Prevent default link behavior

                // @ts-ignore
                $('#personalLinkModal').modal('show');

            }
        };

        const currentContentRef = contentRef.current;
        if (currentContentRef) {
            // Attach the event listener to the modal-body div
            currentContentRef.addEventListener('click', handleContentClick);
        }

        // Cleanup: remove the event listener when the component unmounts
        return () => {
            if (currentContentRef) {
                currentContentRef.removeEventListener('click', handleContentClick);
            }
        };
    }, [cmsPage]);

    console.log("cmsPage?.data?.data?.title: ", cmsPage?.data?.data?.title)

    return (
        <div ref={contentRef} className="inner-data-wrap">
            <div className="cms-page">
                <PageLayout headerName={slug == "terms-and-conditions" ? title : cmsPage?.data?.data?.title || title} onlyTitle={false}>
                    <div className='page-padding-x'>

                        {cmsPage?.data?.data?.title !== "Privacy Policy" && cmsPage?.data?.data?.title !== "Terms and Conditions" &&
                            <img className='cms-logo' src={logo} alt="Logo" />
                        }

                        {
                            cmsPage?.loading ?
                                <>
                                    <Skeleton className='skeleton-loader mt-5' style={{ width: '50%', height: '20px' }} />
                                    <Skeleton className='skeleton-loader my-2' style={{ width: '60%', height: '20px' }} />
                                    <Skeleton className='skeleton-loader my-2' style={{ width: '100%', height: '20px' }} />
                                    <Skeleton className='skeleton-loader my-2' style={{ width: '80%', height: '20px' }} />
                                    <Skeleton className='skeleton-loader my-2' style={{ width: '90%', height: '20px' }} />

                                    <Skeleton className='skeleton-loader mt-5' style={{ width: '50%', height: '20px' }} />
                                    <Skeleton className='skeleton-loader my-2' style={{ width: '60%', height: '20px' }} />
                                    <Skeleton className='skeleton-loader my-2' style={{ width: '100%', height: '20px' }} />
                                    <Skeleton className='skeleton-loader my-2' style={{ width: '80%', height: '20px' }} />
                                    <Skeleton className='skeleton-loader my-2' style={{ width: '90%', height: '20px' }} />
                                </>
                                :
                                <p dangerouslySetInnerHTML={{ __html: cmsPage?.data?.data?.content }}></p>
                        }
                    </div>
                </PageLayout>
            </div>
            <DoNotSellMyPersonalInfoModal cmsPage={cmsPage} />
        </div>
    )
}

export default CmsPages